/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter values to calculate.`)
};

const es_sip_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa valores para calcular.`)
};

const de_sip_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie Werte ein, um zu berechnen.`)
};

const nl_sip_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer waarden in om te berekenen.`)
};

const fr_sip_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez les valeurs pour calculer.`)
};

const it_sip_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immetti i valori per calcolare.`)
};

const pt_br2_sip_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite valores para calcular.`)
};

const pt_sip_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza os valores para calcular.`)
};

const ja_sip_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`計算する値を入力してください。`)
};

const zh_sip_enter_values = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入数值进行计算。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_enter_values = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_enter_values(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_enter_values", locale)
	if (locale === "en") return en_sip_enter_values(inputs)
	if (locale === "es") return es_sip_enter_values(inputs)
	if (locale === "de") return de_sip_enter_values(inputs)
	if (locale === "nl") return nl_sip_enter_values(inputs)
	if (locale === "fr") return fr_sip_enter_values(inputs)
	if (locale === "it") return it_sip_enter_values(inputs)
	if (locale === "pt-BR") return pt_br2_sip_enter_values(inputs)
	if (locale === "pt") return pt_sip_enter_values(inputs)
	if (locale === "ja") return ja_sip_enter_values(inputs)
	return zh_sip_enter_values(inputs)
};